import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { notesReducer } from './notes.reducer';
import { NotesEffects } from './notes.effects';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('notes', notesReducer), EffectsModule.forFeature([NotesEffects])],
  providers: [],
})
export class NotesStoreModule {}
